
import React from 'react';
import { Separator } from "@/components/ui/separator";
import { SessionItem } from './SessionItem';

interface ScheduleDayProps {
  sessions: {
    time: string;
    type: string;
    title: string;
    speaker: string;
    description?: string | null;
  }[];
  title: string;
  animationDelay?: string;
}

export const ScheduleDay = ({ sessions, title, animationDelay = "0ms" }: ScheduleDayProps) => {
  return (
    <div className="bg-gradient-to-br from-white via-gray-50 to-gray-100 backdrop-blur-sm p-6 rounded-lg border border-gray-200 animate-fade-in" style={{ animationDelay }}>
      <h3 className="text-xl text-purple-400 font-semibold mb-4">{title}</h3>
      <div className="space-y-[0.25rem]">
        <div className="grid gap-4">
          {sessions.map((session, index, arr) => (
            <div key={`${session.title}-${index}`}>
              <SessionItem 
                session={session} 
                index={index} 
                animationDelayOffset={animationDelay === "0ms" ? 0 : 450}
              />
              {index < arr.length - 1 && (
                <Separator 
                  orientation="horizontal" 
                  className="my-4 bg-green-500 h-[1px]" 
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
